import dayjs from 'dayjs';

export const checkValidDate = (minDate: Date, date: Date) => {
  return dayjs(date).isAfter(minDate);
};
